import {
  onSnapshot, type DocumentData, type DocumentReference, type DocumentSnapshot,
  type Query, type QuerySnapshot,
} from 'firebase/firestore';
import { subscribeWithDeadline } from './readLoading';

export function listenQuery(
  target: Query<DocumentData>,
  next: (snapshot: QuerySnapshot<DocumentData>) => void,
  fail: (error: Error) => void
) {
  return subscribeWithDeadline<QuerySnapshot<DocumentData>>(
    (onNext, onError) => onSnapshot(target, { includeMetadataChanges: true },
      (snapshot) => { if (!snapshot.metadata.fromCache) onNext(snapshot); }, onError), next, fail
  );
}

export function listenDocument(
  target: DocumentReference<DocumentData>,
  next: (snapshot: DocumentSnapshot<DocumentData>) => void,
  fail: (error: Error) => void
) {
  return subscribeWithDeadline<DocumentSnapshot<DocumentData>>(
    (onNext, onError) => onSnapshot(target, { includeMetadataChanges: true },
      (snapshot) => { if (!snapshot.metadata.fromCache) onNext(snapshot); }, onError), next, fail
  );
}
